module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "uPVwsKdMUTDcQXoIU2kE6R4",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Basic_Bold"
  }, [_c('a', {
    attrs: {
      "id": "u2IlEUDoSDvlRZuIC4yLVB4"
    }
  }), _vm._v("Through the Looking Ass")])]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why do you keep such ugly beasts?”")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("it’s often asked of me.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why not have one horse at least,")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("so beautiful, wild, and free?”")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It seems so plain, so obvious,")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("how could I feel ill-fated?")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("To surround myself with the very best")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("that ever were created.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A friendship now days known by few,")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("the very best companions.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Contented just to pack us through")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("the mountains, plains, and canyons.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It seems forever, more or less,")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("he’s shouldered mankind’s loads")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and brought us through the wilderness")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("with little use for roads.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And while I’m no religious man,")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("it must show good behavior")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("to be chosen as delivery van")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and guardian of the savior.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He provides us with solutions")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("for problems yet uncounted,")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("but his greatest contributions")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("are not when he is mounted.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When you gaze upon a grazing jack,")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("you may see a lowly ass.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("You can be sure he’s looking back")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("‘neath the guise of nibbling grass.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He wears the perfect poker face,")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("he is what you impose.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But while you stand there heels in place,")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("he’s always on his toes.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Unknowing eyes will think they feast")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("upon a silly creature.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A simple, strange, and awkward beast")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("without redeeming feature.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Those that are demanding")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("will find his every fault")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and take each patient standing")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("as a personal assault.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("If then they try to use some force")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and find he can’t be budged.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He’s judged the wrong end of a horse,")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("themselves correctly judged.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But patient, understanding eyes")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("might find a lifelong friend,")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("one to trust when hard times rise,")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("one to count on to the end.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("So, if you see a lowly ass,")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("then that’s just what he’ll be")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("when viewing nature’s looking glass,")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center _idGenParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("you are just what you see.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b22a5bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Chap_01.vue
// module id = 69
// module chunks = 0